/* This is the EMIS Pre Last Student components */

<template>
  <v-container>
    <div>
      <span v-html="title + ' ' + lastAcc"></span>
    </div>
    <div>
      <table style="height: 77px" border="1px;" cellspacing="0px;">
        <tbody>
          <tr style="height: 29px">
            <td
              style="
                width: 250px;
                height: 54px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              កុមារ
            </td>
            <td
              style="
                width: 60px;
                height: 29px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ថ្នាក់កម្រិតទាប
            </td>
            <td
              style="
                width: 60px;
                height: 29px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ថ្នាក់កម្រិតមធ្យម
            </td>
            <td
              style="
                width: 60px;
                height: 29px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ថ្នាក់កម្រិតខ្ពស់
            </td>
            <td
              style="
                width: 60px;
                height: 29px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              ថ្នាក់ចម្រុះ
            </td>
            <td
              style="
                width: 60px;
                height: 29px;
                text-align: center;
                vertical-align: middle;
              "
              colspan="2"
            >
              សរុប
            </td>
          </tr>
          <tr style="height: 25px">
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
            <td class="td-white">សរុប</td>
            <td class="td-white">ស្រី</td>
          </tr>
          <!-- Data Row -->
          <tr v-for="(value, row) in b4.length" :key="row" style="height: 25px">
            <td v-if="row < 3" class="td-title">
              {{ b4[row] + " " + lastAcc }}
            </td>
            <td v-else class="td-title">{{ b4[row] }}</td>
            <td :class="[OnOff[row][0] ? 'td-white' : 'td-light']">
              <numberinput
                v-model="data[row].dt[0]"
                :disabled="!OnOff[row][0]"
                class="number"
              />
            </td>
            <td :class="[OnOff[row][1] ? 'td-white' : 'td-light']">
              <numberinput
                v-model="data[row].dt[1]"
                :disabled="!OnOff[row][1]"
                class="number"
              />
            </td>
            <td :class="[OnOff[row][2] ? 'td-white' : 'td-light']">
              <numberinput
                v-model="data[row].dt[2]"
                :disabled="!OnOff[row][2]"
                class="number"
              />
            </td>
            <td :class="[OnOff[row][3] ? 'td-white' : 'td-light']">
              <numberinput
                v-model="data[row].dt[3]"
                :disabled="!OnOff[row][3]"
                class="number"
              />
            </td>
            <td :class="[OnOff[row][4] ? 'td-white' : 'td-light']">
              <numberinput
                v-model="data[row].dt[4]"
                :disabled="!OnOff[row][4]"
                class="number"
              />
            </td>
            <td :class="[OnOff[row][5] ? 'td-white' : 'td-light']">
              <numberinput
                v-model="data[row].dt[5]"
                :disabled="!OnOff[row][5]"
                class="number"
              />
            </td>
            <td :class="[OnOff[row][6] ? 'td-white' : 'td-light']">
              <numberinput
                v-model="data[row].dt[6]"
                :disabled="!OnOff[row][6]"
                class="number"
              />
            </td>
            <td :class="[OnOff[row][7] ? 'td-white' : 'td-light']">
              <numberinput
                v-model="data[row].dt[7]"
                :disabled="!OnOff[row][7]"
                class="number"
              />
            </td>
            <td class="td-white">
              <strong>{{ row1[row] | blank }}</strong>
            </td>
            <td class="td-white">
              <strong>{{ row2[row] | blank }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
import { b4, lastStudentOnOff } from "@/utils/ascf/preConfig.js";
export default {
  props: ["data", "lastAcc", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      b4: b4,
      OnOff: lastStudentOnOff,
    };
  },
  computed: {
    row1: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 0) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
    row2: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          if (i % 2 === 1) {
            r[ind] = (r[ind] || 0) + Number(b);
          }
        });
        return r;
      }, []);
      return result;
    },
  },
  filters: {
    blank: function (value) {
      if (value == 0) return "";
      return value;
    },
  },
};
</script>

<style scoped>
.number {
  width: 50px;
  text-align: center;
}
.td-title {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
}
.td-white {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: white;
}
.td-light {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
.td-white-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: white;
}
.td-light-long {
  width: 250px;
  height: 25px;
  text-align: left;
  vertical-align: middle;
  background-color: lightgray;
}
</style>